window.usfMobileLikePC = 1;

////replacement for usf.templates.app
window._usfAppTemplate = `<div id="usf_container" class="usf-zone usf-clear" :class="{'usf-filters-horz': usf.settings.filters.horz && !usf.isMobile}">
  
        <div class="usf-sidebar-overlay" @click="_usfSidebarClose"></div>
        <button v-if="!usf.isMobile && hasFilters" class="usf-filter-button usf-close-filter" @click="_usfSidebarClose">
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 64 64" viewBox="0 0 64 64"><g transform="translate(381 231)"><polyline fill="#134563" points="-370.7 -174.7 -373 -177 -327 -223 -324.7 -220.7 -370.7 -174.7"/><polyline fill="#134563" points="-327 -174.7 -373 -220.7 -370.7 -223 -324.7 -177 -327 -174.7"/></g></svg>            <span >Close filter</span>
        </button>
        <button v-if="!usf.isMobile && hasFilters" class="usf-filter-button usf-open-filter" @click="_usfSidebarOpen">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M4 10h7.09a6 6 0 0 0 11.82 0H44a1 1 0 0 0 0-2H22.91A6 6 0 0 0 11.09 8H4a1 1 0 0 0 0 2zM17 5a4 4 0 1 1-4 4A4 4 0 0 1 17 5zM44 23H36.91a6 6 0 0 0-11.82 0H4a1 1 0 0 0 0 2H25.09a6 6 0 0 0 11.82 0H44a1 1 0 0 0 0-2zM31 28a4 4 0 1 1 4-4A4 4 0 0 1 31 28zM44 38H22.91a6 6 0 0 0-11.82 0H4a1 1 0 0 0 0 2h7.09a6 6 0 0 0 11.82 0H44a1 1 0 0 0 0-2zM17 43a4 4 0 1 1 4-4A4 4 0 0 1 17 43z" data-name="Layer 15"/></svg>
            <span v-html="usf.settings.translation.filters"></span>
        </button>
        <div v-if="hasFilters" class="usf-sidebar">
            <span @click="_usfSidebarClose" class="usf-sidebar-close"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 64 64" viewBox="0 0 64 64"><g transform="translate(381 231)"><polyline fill="#134563" points="-370.7 -174.7 -373 -177 -327 -223 -324.7 -220.7 -370.7 -174.7"></polyline><polyline fill="#134563" points="-327 -174.7 -373 -220.7 -370.7 -223 -324.7 -177 -327 -174.7"></polyline></g></svg></span>
            <div   class="usf-filter-wrap">
                <usf-new-filters class="usf-sr-filters"></usf-new-filters>
            </div>
        </div>
       
  
    <usf-new-sr></usf-new-sr>
</div>`;

////replacement for usf.templates.filters
window._usfFiltersTemplate = `<div class="usf-facets usf-no-select usf-zone" >
    <usf-filter-breadcrumb></usf-filter-breadcrumb>
    <!-- Filters Loader -->
    <div v-if="!facets" class="usf-facets__first-loader">
        <template v-for="i in 3">
            <div class="usf-facet"><div class="usf-title usf-no-select"><span class="usf-label"></span></div>
                <div v-if="!usf.settings.filters.horz" class="usf-container"><div class="usf-facet-values usf-facet-values--List"><div class="usf-relative usf-facet-value usf-facet-value-single"><span class="usf-label"></span><span class="usf-value"></span></div><div class="usf-relative usf-facet-value usf-facet-value-single"><span class="usf-label"></span><span class="usf-value"></span></div></div></div>
            </div>
        </template>
    </div>
    <!-- Facets body -->
    <div v-else class="usf-facets__body">
        <usf-filter :facet="f" :key="f.id" v-for="f in facets"></usf-filter>
    </div>
</div>`;

////replacement for _usfFilterBodyTemplate
window._usfNewFilterBodyTemplate = `<!-- Range filter -->
<div v-if="isRange" class="usf-facet-values usf-facet-range">
    <!-- Range inputs -->
    <div class="usf-slider-inputs usf-clear">
        <span class="usf-slider-input__from">
            <span class="usf-slider-input__prefix" v-html="facet.sliderPrefix" v-if="facet.showSliderInputPrefixSuffix"></span>
            <input :readonly="!hasRangeInputs" :value="rangeConverter(range[0]).toFixed(rangeDecimals)" @change="e => onRangeInput(e, range[0], 0)">
            <span class="usf-slider-input__suffix" v-html="facet.sliderSuffix" v-if="facet.showSliderInputPrefixSuffix"></span>
        </span>
        <span class="usf-slider-div">-</span>
        <span class="usf-slider-input__to">
            <span class="usf-slider-input__prefix" v-html="facet.sliderPrefix" v-if="facet.showSliderInputPrefixSuffix"></span>
            <input :readonly="!hasRangeInputs" :value="rangeConverter(range[1]).toFixed(rangeDecimals)" @change="e => onRangeInput(e, range[1], 1)">
            <span class="usf-slider-input__suffix" v-html="facet.sliderSuffix" v-if="facet.showSliderInputPrefixSuffix"></span>
        </span>
    </div>
	<!-- See API reference of this component at https://docs.sobooster.com/search/storefront-js-api/slider-component -->
    <usf-slider :color="facet.sliderColor" :symbols="facet.sliderValueSymbols" :prefix="facet.sliderPrefix" :suffix="facet.sliderSuffix" :min="facet.min" :max="facet.max" :pips="facet.range[0]" :step="facet.range[1]" :decimals="rangeDecimals" :value="range" :converter="rangeConverter" @input="onRangeSliderInput" @change="onRangeSliderChange"></usf-slider>
</div>
<!-- List + Swatch filter -->
<div v-else ref="values" :class="'usf-facet-values usf-scrollbar usf-facet-values--' + facet.display + (facet.navigationCollections ? ' usf-navigation' : '') + (facet.valuesTransformation ? (' usf-' + facet.valuesTransformation.toLowerCase()) : '') + (facet.circleSwatch ? ' usf-facet-values--circle' : '')" >
    <!-- Filter options -->                
    <usf-filter-option v-for="o in visibleOptions" :facet="facet" :option="o" :key="o.id ? o.id : o.label+'_'+o.min+'_'+o.max"></usf-filter-option>
</div>

<!-- More -->
<div v-if="isMoreVisible" class="usf-more" @click="onShowMore" v-html="loc.more"></div>`;

////replacement for usf.templates.filter
window._usfFilterTemplate =
	`<div v-if="canShow" class="usf-facet" :class="{ 'usf-has-filter': isInBreadcrumb}">
        <!-- Filter title -->
        <div class="usf-clear">
            <div class="usf-title usf-no-select" @click.prevent.stop="onExpandCollapse">
                <button class="usf-label usf-btn" v-html="facet.title" :aria-label="usf.utils.format(loc.filterBy,facet.title)" :aria-expanded="!collapsed"></button>
                <usf-helptip v-if="facet.tooltip" :tooltip="facet.tooltip"></usf-helptip>            
                <!-- 'Clear all' button to clear the current facet filter. -->
                <button v-if="isInBreadcrumb" class="usf-clear-all usf-btn" :title="loc.clearFilterOptions" :aria-label="usf.utils.format(loc.clearFiltersBy,facet.title)" @click.prevent.stop="onClear" v-html="loc.clear"></button>
            </div>
        </div>

        <!-- Filter body -->
        <div class="usf-container">
            <!-- Search box -->
            <input v-if="hasSearchBox" class="usf-search-box" :placeholder="loc.filterOptions" :value="term" @input="v => term = v.target.value">

            ` +
	_usfNewFilterBodyTemplate +
	`
        </div>
</div>`;

////replacement for _usfSearchResultsViewsTpl
window._usfNewSearchResultsViewsTpl =
	/*inc_begin_search-views*/
	` <div v-if="!usf.isMobile" class="usf-col-sw">
    <button  class="usf-minus" @click="onMinus">
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 29 29" xml:space="preserve"><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M22 14.5H7"/></svg>
    </button>
    <span  v-html="gridCol"></span>
    <button  class="usf-plus" @click="onPlus">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"/></svg>
    </button>
</div>`;

//replacement for <usf-filters> component

window._usfNewFacetFilters = {
	template: window._usfFiltersTemplate,
	data() {
		return {
			// facets fetched from the server
			facets: null,

			// facet filters
			facetFilters: null,

			// collapsed facet groups
			collapsed: {},

			// retains the temporary the number of loaded items for the corresponding facet filters
			loadedItems: {},

			// retains the terms used to filter options in each filter panel.
			terms: {},

			// The selected facet in mobile mode.
			mobileSelectedFacetId: null,

			horz: usf.settings.filters.horz,
		};
	},

	beforeMount() {
		// set localization here instead of in data() since we dont need reactivity for `loc`
		this.loc = usf.settings.translation;

		this.__init();

		var queryRewriter = this.__qr;

		// parse the facet filters from the query params.
		this.facetFilters = queryRewriter.facetFilters;

		// handle browser's query change event.
		queryRewriter.addChangedEventListener(() => {
			this.facetFilters = queryRewriter.facetFilters;
		});
	},

	mounted() {
		// move to the document.body so we stay on top of theme elements.
		if (usf.isMobile)
			document
				.querySelector(".usf-mobile-filters-wrapper")
				.appendChild(this.$el);

		// when user switches back to desktop mode, we change the element.
		usf.event.add("mobile_changed", this.__onMobileChanged);
	},

	beforeDestroy() {
		console.log("[USF] destroy in base facets");

		// remove events.
		usf.event.remove("sr_updated", this.__onSrUpdated);
		usf.event.remove("mobile_changed", this.__onMobileChanged);

		try {
			document
				.querySelector(".usf-mobile-filters-wrapper")
				.removeChild(this.$el);
		} catch (e) {}
	},

	provide() {
		return {
			root: this,
		};
	},

	computed: {
		// true if there is only one Facet filter
		isSingleFacetMode() {
			// should not check mobileSelectedFacet, as we need to disable the Back button when a Price filter is selected then user changes the slider.
			return (
				/*!this.mobileSelectedFacet && */ this.facets &&
				this.facets.length === 1
			);
		},

		// return the selected facet filters in mobile view
		mobileSelectedFacet() {
			return this.facets
				? this.facets.find((f) => f.id === this.mobileSelectedFacetId)
				: null;
		},
	},

	methods: {
		__init() {
			// handle 'sr_updated' event. This event is raised when the search results app has finished fetching data from the server.
			usf.event.add("sr_updated", this.__onSrUpdated);
			if (usf.search) {
				var r = usf.search.result;
				if (r)
					this.__onSrUpdated(null, {
						facets: r.facets,
					});
			}

			// parse the facet filters from the query params.
			this.__qr = usf.queryRewriter;
		},

		__onSrUpdated(sender, e) {
			var newFacets = e.facets;

			// try to make properties in this.facets not reactive.
			// purposely use this for loop instead of using `=` operator
			if (newFacets) {
				if (!this.facets && this.horz) {
					// mark all filters as collapsed if no filters are selected
					for (var i = 0; i < newFacets.length; i++)
						this.$set(this.collapsed, newFacets[i].id, 1);
				}

				this.facets = [];
				for (var i = 0; i < newFacets.length; i++)
					this.facets[i] = newFacets[i];
			} else this.facets = null;
		}, 

		__onMobileChanged(sender, e) {
			if (usf.isMobile)
				document
					.querySelector(".usf-mobile-filters-wrapper")
					.appendChild(this.$el);
			else {
				var parent = this.$parent;
				var ppel;

				do {
					var pel = parent.$el;
					ppel = pel.querySelector(".usf-facets-container");
					if (ppel) break;
					if (pel.id === "usf_container") ppel = pel;
					parent = parent.$parent;
				} while (parent);

				ppel.insertBefore(this.$el, ppel.children[0]);
			}
		},

		canShowFilter(f) {
			var isRange = f.min !== undefined;
			if (isRange) return f.min !== f.max;

			if (f.navigationCollections) {
				var items = f.navigationCollectionsMenu;
				if (items) return items.length;
			}

			return f.labels.length;
		},

		// this component does not have `refresh` method since the refresh operation is done in the SearchResults component.
		formatBreadcrumbLabel: ft_formatRefineByLabel,
		formatFacetLabel: ft_formatFacetLabel,

		onMobileBack(close) {
			if (close || this.singleFacetMode)
				// close the filter
				this.$el.classList.remove("usf-on");
			else this.mobileSelectedFacetId = null;
		},

		onMobileSelectFacet(f) {
			this.mobileSelectedFacetId = f.id;
		},

		// apply the specified facet filters to the query
		applyFacetFilters(facetFilters) {
			this.__qr.facetFilters = facetFilters;
		},

		// select all values in this facet filter
		selectFacetFilter(facetData) {
			var facetName = facetData.facetName;
			var filterId = facetData.id;
			var facetFilters = this.facetFilters;
			var filter;
			if (facetFilters) filter = facetFilters[filterId];

			if (!filter) {
				filter = [facetName, []];
				if (!facetFilters) facetFilters = {};
				facetFilters[filterId] = filter;
			}

			// filter[0] is the facet name
			// filter[1] is the list of values
			var existingValues = filter[1];
			var isCollectionsFacet = facetName === "collections";

			facetData.labels.forEach((v) => {
				var nindex = existingValues.indexOf(v);
				if (nindex === -1)
					existingValues.push(isCollectionsFacet ? v.id : v.label);
			});

			// QueryRewriter handles all the transformation of the query variables.
			this.__qr.facetFilters = facetFilters;
		},

		// remove a facet filter label
		removeFacetFilter(facetId, filterLabel) {
			var facetFilters = this.facetFilters;
			if (!facetFilters) return;

			if (!filterLabel) delete facetFilters[facetId];
			else {
				var filter = facetFilters[facetId];
				if (!filter) return;

				var existingValues = filter[1];
				var nindex = existingValues.indexOf(filterLabel);
				if (nindex === -1) existingValues.push(label);
				else existingValues.splice(nindex, 1);

				if (!existingValues.length) {
					delete facetFilters[facetId];
				}
			}

			// this will change the query params
			this.__qr.facetFilters = facetFilters;
		},

		removeAllFacetFilters() {
			// remove some query vars
			this.__qr.removeAllFacetFilters();
		},
	},
};

//facts ultis
// we use this tempData to store some temporary value related to filters.
// even though we can store tempData in this component. I explicitly move it outside to make the component more lightweight.
var ft_priceFacetNames = ["price"];
var ft_horzMouseDownDlg;

// get a facet label
function ft_genQueryValue(facetLabelObj) {
	var val;

	// is it a range slider?
	if (facetLabelObj.min !== undefined) {
		val = (facetLabelObj.minInclusive ? ":" : "") + facetLabelObj.min + " ";
		if (facetLabelObj.max < maxInt)
			val += (facetLabelObj.maxInclusive ? ":" : "") + facetLabelObj.max;

		// append the label format so we know how to display it.
		val += " " + facetLabelObj.label;
	}
	// otherwise, we need to use the `label`
	else val = facetLabelObj.label;

	return val;
}
function _usfSidebarClose() {
	document.body.classList.remove("usf-sidebar-open");
}
function _usfSidebarOpen() {
	document.body.classList.add("usf-sidebar-open");
}
function ft_genFacetOptionLabel(opt, facetData, swatchImage, isMobile) {
	//if (!swatchImage || isMobile) {
	// in-stock & out-of-stock
	var inStockLabel = facetData.inStockLabel;
	if (inStockLabel !== undefined) {
		var outOfStockLabel = facetData.outOfStockLabel;

		return opt.label === "1" ? inStockLabel : outOfStockLabel;
	}

	if (!opt.label && facetData.facetName === "reviewRating")
		return ft_buildStarLabel(opt, facetData.ratingColor);

	// range with min + max?
	if (opt.min !== undefined) return ft_getRangeLabel(opt, facetData);

	// opt.llabel is the localized version of opt.label if any
	return ft_formatFacetLabel(opt.llabel || opt.label, facetData);
	//}

	//return '&nbsp;';
}

function ft_getRangeLabel(label, facetData) {
	var min = label.min;
	var max = label.max;

	var isPrice = ft_priceFacetNames.includes(facetData.facetName);

	if (isPrice) {
		min = usfFormatDecimal(min * _settings.currencyRate);
		min = $r_format(_settings.priceFormat, min);
	} else min = usfFormatDecimal(min);

	if (max !== maxInt) {
		if (isPrice) {
			max = usfFormatDecimal(max * _settings.currencyRate);
			max = $r_format(_settings.priceFormat, max);
		} else {
			max = usfFormatDecimal(max);
		}
	}

	return $r_format(label.label, min, max);
}

function ft_formatRefineByLabel(facetData, facetName, label) {
	// is numeric range?
	if (facetData.numericRange) {
		var n = label.indexOf(" ");
		if (n !== -1) {
			var min = label.substr(0, n),
				max,
				labelFormat;
			var m = label.indexOf(" ", n + 1);
			if (m === -1) {
				max = label.substr(n + 1);
			} else {
				max = label.substr(n + 1, m - n - 1);
				labelFormat = label.substr(m + 1);
			}

			var minInclusive = min[0] === ":";
			var maxInclusive = max[0] === ":";

			min = trimColons(min);
			max = trimColons(max);

			// convert to floats
			var isPrice = ft_priceFacetNames.includes(facetName);
			var cvtTo = ft_getConverter(isPrice, facetData.valueFormula);

			// convert to floats
			var fmin = cvtTo(parseFloat(min));
			var fmax = max.length ? cvtTo(parseFloat(max)) : -1;

			if (facetName === "reviewRating" && !labelFormat) {
				return ft_buildStarLabel(
					{
						min: fmin,
						minInclusive: minInclusive,
						max: fmax,
						maxInclusive: maxInclusive,
					},
					facetData.ratingColor
				);
			}

			if (!labelFormat) {
				if (fmin < facetData.min) min = facetData.min.toString();

				if (fmax > facetData.max) max = facetData.max.toString();

				labelFormat = facetData.rangeFormat || "{0} - {1}";
			}

			var range = facetData.range;
			var decimals;
			if (range) decimals = range[2];

			// is price?
			if (isPrice) {
				min = $r_format(
					_settings.priceFormat,
					usfFormatDecimal(fmin, decimals)
				);
				if (max)
					max = $r_format(
						_settings.priceFormat,
						usfFormatDecimal(fmax, decimals)
					);
			} else {
				min = usfFormatDecimal(fmin, decimals);
				if (max) max = usfFormatDecimal(fmax, decimals);
			}

			return $r_format(labelFormat, min, max);
		}
	} else if (facetData.inStockLabel !== undefined) {
		return label === "1" ? facetData.inStockLabel : facetData.outOfStockLabel;
	}
	// need to lookup the collection title as label here is the collection ID
	else if (facetData.facetName === "collections") {
		var labelId = parseInt(label);
		if (!Number.isNaN(labelId)) {
			// find the label by collection ID.
			// find in collection map
			var colsMap = usf.collectionsByUrlName;
			for (var k in colsMap) {
				var c = colsMap[k];
				if (c.id === labelId) {
					label = c.title;
					break;
				}
			}
		}
	}

	return ft_formatFacetLabel(label, facetData);
}

function ft_formatFacetLabel(label, facetData) {
	var trans = facetData.valuesTransformation;
	if (trans) {
		return '<span class="usf-' + trans.toLowerCase() + '">' + label + "</span>";
	}
	return label;
}

function ft_scrollIntoView() {
	setTimeout(() => {
		var r = usf_container.getBoundingClientRect();
		if (r.top <= -50) _utils.scrollTo(usf_container.scrollTop, 800);
	}, 100);
}

function ft_buildStarLabel(label, color) {
	var num;
	if (label.minInclusive || !label.maxInclusive) num = label.min;
	else num = label.max;

	var children = '<span class="usf-stars" style="color:' + color + '">';
	for (var i = 1; i <= 5; i++) {
		children +=
			'<i class="usf-icon usf-icon-star' + (i > num ? "-empty" : "") + '"></i>';
	}
	children += "</span>";
	return children;
}

function ft_getConverter(isPrice, valueFormula) {
	if (!valueFormula && !isPrice) {
		return (a) => a;
	} else {
		return function (a) {
			if (isPrice) a = _utils.convertPrice(a);

			if (valueFormula) {
				eval("var value=" + a);
				a = eval("(" + valueFormula + ")");
			}

			return a;
		};
	}
}

function _ftGetNavigationCollectionItems(facetData) {
	var menu = facetData.navigationCollectionsMenu;
	if (menu) {
		var labels = facetData.labels;
		var items = [];

		for (var i = 0; i < menu.length; i++) {
			var m = menu[i];
			var lbl = labels.find((i) => i.id === m.collection.id);

			if (!lbl) {
				if (facetData.navigationCollectionsKeepMain) items.push(m);
			} else
				items.push(
					Object.assign(
						{
							id: lbl.id,
							value: lbl.value,
						},
						m
					)
				);
		}

		return items;
	}
}

//END HORIZONTAL ON MOBILE
